export const emptyAvatar = { id: null, thumbnailUrl: '' };

export const initialState = ({
  fullname,
  emailAddress,
  avatarId,
  avatarUrl,
  cellphoneNumber,
  address,
  bio,
  pageName,
  links= [],
  tags = [],
}) => ({
  fullname,
  emailAddress,
  avatar: { id: avatarId, thumbnailUrl: avatarUrl },
  cellphoneNumber,
  address: address,
  bio,
  pageName,
  currentTags: tags,
  editLinksIsVisible: false,
  currentLinks: links,
  editContactInfoIsVisible: false,
  currentContactInfo: null,
});

export const types = {
  SET_PAGE_NAME: 'SET_PAGE_NAME',
  SET_FULLNAME: 'SET_FULLNAME',
  SET_AVATAR: 'SET_AVATAR',
  SET_BIO: 'SET_BIO',
  SET_EMAIL_ADDRESS: 'SET_EMAIL_ADDRESS',
  SET_CELLPHONE_NUMBER: 'SET_CELLPHONE_NUMBER',
  SET_ADDRESS: 'SET_ADDRESS',
  SET_TAGS: 'SET_TAGS',
  SET_EDIT_LINKS_IS_VISIBLE: 'SET_EDIT_LINKS_IS_VISIBLE',
  SET_CURRENT_LINKS: 'SET_CURRENT_LINKS',
  SET_EDIT_CONTACT_INFO_IS_VISIBLE: 'SET_EDIT_CONTACT_INFO_IS_VISIBLE',
  SET_CURRENT_CONTACT_INFO: 'SET_CURRENT_CONTACT_INFO',
  SET_MULTI: 'SET_MULTI',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_PAGE_NAME:
      return { ...state, pageName: payload };
    case types.SET_FULLNAME:
      return { ...state, fullname: payload };
    case types.SET_AVATAR:
      return { ...state, avatar: payload };
    case types.SET_BIO:
      return { ...state, bio: payload };
    case types.SET_TAGS:
      return { ...state, currentTags: payload };
    case types.SET_EMAIL_ADDRESS:
      return { ...state, emailAddress: payload };
    case types.SET_CELLPHONE_NUMBER:
      return { ...state, cellphoneNumber: payload };
    case types.SET_ADDRESS:
      return { ...state, address: payload };
    case types.SET_EDIT_CONTACT_INFO_IS_VISIBLE:
      return { ...state, editContactInfoIsVisible: payload };
    case types.SET_CURRENT_CONTACT_INFO:
      return { ...state, currentContactInfo: payload };
    case types.SET_EDIT_LINKS_IS_VISIBLE:
      return { ...state, editLinksIsVisible: payload };
    case types.SET_CURRENT_LINKS:
      return { ...state, currentLinks: payload };
    case types.SET_MULTI:
      return { ...state, ...payload };
    default:
      throw new Error();
  }
};
